import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DashboardMeasurePatientProd } from '@models/dashboard-measure-patient.model';

export interface ValidationConfirmationData {
  patient: DashboardMeasurePatientProd;
  action: 'remove' | 'validate';
}

@Component({
  selector: 'app-patient-validation-confirmation-modal',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule
  ],
  templateUrl: './patient-validation-confirmation-modal.component.html',
  styleUrls: ['./patient-validation-confirmation-modal.component.css']
})
export class PatientValidationConfirmationModalComponent {
  constructor(
    public dialogRef: MatDialogRef<PatientValidationConfirmationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ValidationConfirmationData
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  get isRemoveAction(): boolean {
    return this.data.action === 'remove';
  }

  get modalTitle(): string {
    return this.isRemoveAction ? 'Remove Validation' : 'Validate Patient';
  }

  get modalMessage(): string {
    const patientInfo = `${this.data.patient.patientFirstName} ${this.data.patient.patientLastName} (MRN: ${this.data.patient.patientMRN})`;
    
    if (this.isRemoveAction) {
      return `Are you sure you want to remove validation for patient ${patientInfo}?`;
    } else {
      return `Are you sure you want to validate patient ${patientInfo}?`;
    }
  }

  get confirmButtonText(): string {
    return this.isRemoveAction ? 'Remove Validation' : 'Validate';
  }

  get confirmButtonColor(): string {
    return this.isRemoveAction ? 'warn' : 'primary';
  }

  get iconName(): string {
    return this.isRemoveAction ? 'warning' : 'check_circle';
  }

  formatValidationDate(dateString: string): string {
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'short', 
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch {
      return dateString;
    }
  }
}